import * as Types from '../../../../gql/__generated/graphql.types';

import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { graphqlFetcher } from '@/modules/common/services/graphqlFetcher';
export type RelatedProductsQueryVariables = Types.Exact<{
  id: Types.Scalars['String']['input'];
}>;


export type RelatedProductsQuery = (
  { __typename?: 'Query' }
  & { relatedProducts?: Types.Maybe<(
    { __typename?: 'RelatedProducts' }
    & Pick<Types.RelatedProducts, 'productList'>
  )> }
);



export const RelatedProductsDocument = `
    query relatedProducts($id: String!) {
  relatedProducts(id: $id) {
    productList
  }
}
    `;

export const useRelatedProductsQuery = <
      TData = RelatedProductsQuery,
      TError = unknown
    >(
      variables: RelatedProductsQueryVariables,
      options?: Omit<UseQueryOptions<RelatedProductsQuery, TError, TData>, 'queryKey'> & { queryKey?: UseQueryOptions<RelatedProductsQuery, TError, TData>['queryKey'] }
    ) => {
    
    return useQuery<RelatedProductsQuery, TError, TData>(
      {
    queryKey: ['relatedProducts', variables],
    queryFn: graphqlFetcher<RelatedProductsQuery, RelatedProductsQueryVariables>(RelatedProductsDocument, variables),
    ...options
  }
    )};

useRelatedProductsQuery.getKey = (variables: RelatedProductsQueryVariables) => ['relatedProducts', variables];


useRelatedProductsQuery.fetcher = (variables: RelatedProductsQueryVariables, options?: RequestInit['headers']) => graphqlFetcher<RelatedProductsQuery, RelatedProductsQueryVariables>(RelatedProductsDocument, variables, options);
